export default __webpack_public_path__ + "static/media/Cuirass of Conajohara.015c01fa.jpg";